// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__score-description p{margin-bottom:0}.card__score-description{max-width:910px}", ""]);
// Exports
module.exports = exports;
